<template>
	<div :class="[companyClass, canScroll]" v-loading="pageLoading" element-loading-text="Loading..."
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
		v-show="userPermissionsFilter.admin">
		<div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<div class="page-header">
				<h1 class="pageTitle">{{ this.companyName }} System USERS Permissions REPORT</h1>
				<h4>Users</h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>reports</el-breadcrumb-item>
					<el-breadcrumb-item>mts users</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<!--<div class="toolbar-box flex">
				  <div class="flex box grow">
					  <el-date-picker type="date" placeholder="Registrations From" v-model="fromdate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @input="refreshCompanies" style="padding-right:20px;"></el-date-picker>
					  <el-date-picker type="date" placeholder="Registrations To" v-model="todate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @input="refreshCompanies" :picker-options="{disabledDate: disableAllDatesAfterToday}"></el-date-picker>
					  <el-select v-model="preApproved" @change="refreshCompanies" placeholder="Select Customer Status in Dropdown" size="">
						  <el-option value="0" label="All">All</el-option>
						  <el-option value="1" label="Pending">Pending</el-option>
						  <el-option value="2" label="IPRS Approval">IPRS Approval</el-option>
						  <el-option value="3" label="Manual Approval">Manual Approval</el-option>
					  </el-select>
				  </div>
			  </div>-->

			<resize-observer @notify="handleResize" />
			<div class="table-responsive">
				<table class="table" id="datatable" style="color:white;">
					<thead>
						<tr>
							<th>First Name</th>
							<th>Middle Name</th>
							<th>Last Name</th>
							<th>Mobile</th>
							<th>Email</th>
							<th>Company Name</th>
							<th>Registration Date</th>
							<th>Permission Name</th>
							<th>Permission Date</th>
							<th>Permission Description</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in mtsdata" :key="item.id">
							<td>{{ item.firstName }}</td>
							<td>{{ item.middleName }}</td>
							<td>{{ item.lastName }}</td>
							<td>{{ item.mobile }}</td>
							<td>{{ item.email }}</td>
							<td>{{ item.companyName }}</td>
							<td>{{ formatShortDate(item.registrationDate) }}</td>
							<td>{{ item.permissionName }}</td>
							<td>{{ formatShortDate(item.permisionDate) }}</td>
							<td>{{ item.permisionDescription }}</td>
						</tr>
					</tbody>
				</table>
			</div>



		</div>
	</div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';

import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'companyUserPermissions',
	data: function () {
		return {
			fromdate: '',
			companyID: '',
			companyName: '',
			todate: '',
			preApproved: '',
			mtsdata: '',
			//IdProfile = "data:image/png;base64," + response.data;
		}
	},
	methods: {
		refreshCompanies() {
			this.startLoader("Fetching Details...");
			this.getMTSUserPermissions(this.companyID)
				.then((result) => {
					$("#datatable").dataTable().fnDestroy();
					this.mtsdata = result;
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				})
				.catch((err) => {
					this.stopLoader();
				});
		},
		initDt() {
			var cmp = this.loggedInCompany.name + " Transactions";
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				retrieve: true,
				"pageLength": 50,
				dom: 'Blfrtip',
				"aaSorting": [],
				buttons: [
					'print'
				],
				initComplete: function () {
					var api = this.api();
					// api.columns(4).every( function () {
					//     var column = this;
					//     var select = $('<select><option value="">Filter Kyc Status</option></select>')
					//         .appendTo( $(column.footer()).empty() )
					//         .on( 'change', function () {
					//             var val = $.fn.dataTable.util.escapeRegex(
					//                 $(this).val()
					//             );
					//             column
					//                 .search( val ? '^'+val+'$' : '', true, false )
					//                 .draw();
					//         });

					//     column.data().unique().sort().each( function ( d, j ) {
					//         select.append( '<option value="'+d+'">'+d+'</option>' )
					//     } );
					// } );
				},
			});
		}
	},
	created() {
		const that = this;
		that.startTimer();
		that.getLoggedInCompany()
			.then((loggedInCompany) => {
				that.companyID = loggedInCompany.id;
				that.companyName = loggedInCompany.name;
				that.refreshCompanies();
			})
			.catch(err => console.log(err));
	},
	mixins: [PermissionsMixins]
}
</script>



<style>
.table thead tr,
.table .tbody,
.table .tbody tr {
	white-space: nowrap;
}

.table thead tr th {
	padding: 5px 17px;
	padding-left: 5px;
	background-color: #1b1f27;
	font-weight: bold;
	color: rgba(255, 255, 255, 0.4);
}

table.dataTable tbody tr {
	background-color: #191d24;
}

table.dataTable {
	margin-left: 0px;
	text-align: left;
}

.avatar-box {
	background: #3773e2;
	margin-bottom: 50px;
	position: relative;
}

.avatar-box img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	position: relative;
	bottom: -50px;
	display: block;
	margin: 0 auto;
	background: white;
	border: 2px solid #3773e2;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
	color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
	color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
	color: white !important;
}
</style>